import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("session_token")}` } });

// Manually credit an estimate to a marketing spend source (overrides automatic matching).
export function LeadSourcePicker({ lead, onChange }) {
  const [sources, setSources] = useState([]);
  const [value, setValue] = useState(lead.marketing_source_id || "");
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/marketing/sources`, auth()).then((r) => setSources(r.data.sources)).catch(() => {});
  }, []);
  useEffect(() => setValue(lead.marketing_source_id || ""), [lead.lead_id, lead.marketing_source_id]);
  if (!sources.length) return null;
  const save = async (v) => {
    setValue(v);
    try {
      await axios.put(`${BACKEND_URL}/api/estimates/${lead.lead_id}/marketing-source`, { source_id: v || null }, auth());
      toast.success("Marketing source updated");
      onChange?.(v || null);
    } catch (e) { toast.error("Failed to update source"); }
  };
  return (
    <label className="flex items-center gap-2 text-sm" data-testid="lead-source-picker">
      <span className="text-zinc-600 shrink-0">Marketing source</span>
      <select value={value} onChange={(e) => save(e.target.value)} className="flex-1 px-2 py-1.5 border border-zinc-300 rounded-lg text-sm bg-white"
        data-testid="lead-source-select">
        <option value="">Automatic{lead.channel ? ` (${lead.channel})` : ""}</option>
        {sources.map((s) => <option key={s.source_id} value={s.source_id}>{s.name}</option>)}
      </select>
    </label>
  );
}
